module.exports = __webpack_public_path__ + "media/18.581a51f7.mp3";